<template>
  <div class="data-source-info" :class="{ mobile: isMobile }">
    <div>
      <span @click="showContent = !showContent" class="data-source-info__link"
        >Data source
        <fa aria-hidden="true" :icon="showContent ? 'times' : 'caret-down'"></fa
      ></span>
    </div>
    <div class="data-source-info__message" v-if="showContent">
      <div class="data-source-info__summary">
        <div class="data-source-info__left">Data source</div>
        <fa
          class="data-source-info__right"
          aria-hidden="true"
          @click="showContent = !showContent"
          :icon="showContent ? 'times' : 'caret-down'"
        ></fa>
      </div>
      <div class="data-source-info__content">
        DASH collects data from more than 60 honeynet sensors spread across more
        than 15 economies in the Asia Pacific.
        <router-link to="/data-source" target="_blank">
          <a>
            <span>More info</span>
          </a>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      showContent: false
    };
  },
  computed: {
    ...mapGetters(['isMobile'])
  }
};
</script>

<style lang="scss" scoped>
.data-source-info {
  position: relative;
  width: 100%;
  float: right;

  @media screen and (max-width: 425px) {
    width: 300px;
  }

  &__link {
    cursor: pointer;
    float: right;
  }

  &__message {
    position: absolute;
    top: 0;
    left: -10rem;
    background: #fff;
    display: inline-block;
    margin-bottom: 1rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
    z-index: 100;
  }

  &__summary {
    display: flex;
    align-items: center;
    min-height: 2.5rem;
    font-weight: bold;
    background-color: #e6e6e6;
    padding: 0.5rem 1rem;

    svg:first-child {
      margin-right: 10px;
    }

    svg:last-child {
      margin-left: auto;
      text-align: right;
      cursor: pointer;
    }
  }

  &__content {
    padding: 0.5rem 1rem;
  }

  &__left {
    float: left;
  }

  &__right {
    float: right;
  }
}

.mobile.data-source-info {
  width: 100%;

  .data-source-info__link {
    font-size: 0.8rem;
  }
}
</style>
